import { useQuery } from "@tanstack/react-query";
import { useExportWizardModalContext } from "PFApp/booking/parts/reports/top_actions_panel/export_wizard/export_wizard_modal_provider";
import { fetchExportData } from "PFCore/services/export_booking";

import { exportDataKeys } from "./query_keys";

export const useExportData = () => {
  const {
    state: {
      data: { selectedFields }
    }
  } = useExportWizardModalContext();

  const queryKey = exportDataKeys.fields(selectedFields);

  return useQuery(queryKey, () => fetchExportData(), {
    placeholderData: { entries: [], meta: { total: 0 } }
  });
};
